import { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, FieldProps, FormikProps } from "formik";
import { IcomDropdown, Option } from "src/components/icom-dropdown";

// Components
import Logo from "src/assets/images/icom-logo-branco.png";
import IcomInput from "src/components/formik/icom-input";
import { BgFeedback } from "src/assets/svgs";

// Models
import FinishStatus from "src/models/finish-status";
import { useAppSelector, useStartTyping } from "src/store/hooks";

export default function Feedback({
  onSubmit,
  show = false,
  finishStatuses = [],
  preSelectedStatus,
}: {
  onSubmit: Function;
  show: boolean;
  preSelectedStatus?: string;
  finishStatuses: Array<FinishStatus>;
}) {
  const { userInfo } = useAppSelector((state) => state.auth);
  const submitHandler = (values: any) => {
    setShow(false);

    onSubmit({
      ...values,
    });
  };
  const initialValues = {
    status_finalizador: preSelectedStatus || "",
    observacao: "",
  };
  const [internalShow, setShow] = useState(false);
  const [hasTransitionedIn, setTransitionedIn] = useState(false);
  const [showWDelay, setShowWDelay] = useState(false);
  const [delayCallback, setDelayCallback] = useState(false);

  // Refs
  const animationTimeoutRef = useRef<number | ReturnType<typeof setTimeout>>(undefined);
  const obsRef = useRef<HTMLInputElement | null>(null);
  const formikRef = useRef<FormikProps<typeof initialValues>>(null);

  // Map dropdown options
  const listOptions = finishStatuses.map((s) => ({
    id: s.id,
    label: s.status,
    value: s.status,
  }));

  // Animation effect
  useEffect(() => {
    clearTimeout(animationTimeoutRef.current);

    // Start
    if (internalShow && !hasTransitionedIn) {
      setTransitionedIn(true);

      animationTimeoutRef.current = setTimeout(() => setShowWDelay(true), 200);
    }

    // End
    else if (!internalShow && hasTransitionedIn) {
      setTimeout(() => setTransitionedIn(false), 10000);
      animationTimeoutRef.current = setTimeout(() => setShowWDelay(false), 200);
    }
  }, [internalShow]);

  useEffect(() => {
    setShow(show);
  }, [show, obsRef.current]);

  useStartTyping(obsRef.current, () => submitHandler(formikRef.current?.values), 40000, 10000, 5000, delayCallback);

  return internalShow || hasTransitionedIn ? (
    <div id="feedback" className="bg-primary-blue-400 dark:bg-neutral-gray-900 w-full h-full absolute top-0 left-0 flex items-center justify-center overflow-hidden">
      <div
        className={`feedback-content-area w-[560px] relative transition-all ${showWDelay ? "opacity-100 translate-x-0" : "opacity-0 translate-x-96"}
        )}`}
      >
        <img src={Logo} className="mb-10 max-w-[88px] relative z-10" />

        <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={submitHandler}>
          <Form className="relative z-10">
            <div className="p-8 bg-white rounded-t-md">
              <h4 className="text-xl font-bold mb-6">Deixe seu feedback</h4>

              <label htmlFor="status_finalizador" className="font-bold mb-3 block">
                Status finalizador
              </label>
              <Field name="status_finalizador">
                {({ field, form }: FieldProps) => (
                  <IcomDropdown
                    className="mb-6"
                    onClose={() => setDelayCallback(false)}
                    onOpen={() => setDelayCallback(true)}
                    onChange={(option: Option) => {
                      form.setFieldValue("status_finalizador", option.value);
                    }}
                    selectedOption={field.value}
                    listOptions={listOptions}
                  />
                )}
              </Field>

              <label htmlFor="observacao" className="font-bold mb-3 block">
                Você tem algum comentário, reclamação ou sugestão?
              </label>
              <Field innerRef={obsRef} type="textarea" placeholder="Deixe sua observação aqui" name="observacao" rows="8" noresize component={IcomInput} />
            </div>

            <div className="p-8 flex items-end flex-col bg-neutral-gray-50 rounded-b-md">
              <button type="submit" className="bg-primary-blue-400 text-white text-base px-4 py-3 hover:bg-primary-blue-500 ">
                Enviar
              </button>
            </div>
          </Form>
        </Formik>

        <BgFeedback className="absolute left-[-100px] bottom-[-100px]" />
        <BgFeedback className="absolute right-[-100px] top-[-100px]" />
      </div>
    </div>
  ) : null;
}
